module.exports = __webpack_public_path__ + "static/img/00_first_iphone.f5017e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moments/00_first_iphone.png
// module id = mxwg
// module chunks = 1